import { Link } from "react-router-dom";
import PageHeader from "../../components/PageHeader"
import { Button, Popconfirm, PopconfirmProps, Spin, Table, Typography, message } from "antd";
import { AuthService } from "../../services/AuthService";
import { useContext, useEffect, useState } from "react";
import Card from "../../components/Card";
import styled from "styled-components";
import { DeleteOutlined } from "@ant-design/icons";
import LayoutContext from "../../context/layoutContext";
import { Brand } from "../../models/brand";
import { UserContext } from "../../context/userContext";

const { Title } = Typography;




const Brands = () => {

  const {  user } = useContext(UserContext);

  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);

  const [brands, setBrands] = useState<Brand[]>([]);

  const [columns, setColumns] = useState([
    {
      title: 'Brendi',
      dataIndex: 'name',
      key: 'name',
      width: 150, // Set the fixed width for the column
  
    },
    {
      title: 'Përshkrim',
      dataIndex: 'description',
      key: 'description',
      ellipsis: true,
    },
    ...(user?.details?.roleName === 'Admin' ? [{
      title: 'ACTIONS',
      dataIndex: 'actions',
      key: 'actions',
      width: 80,
      render: (_, record) => {
        return (
          <Popconfirm
            title="Fshij brendin"
            description="A jeni i sigurte per veprimin?"
            okText="Po"
            cancelText="Anulo"
            onConfirm={() => deleteBrand(record)}
          >
            <Button type="primary" danger size="small"><DeleteOutlined /></Button>
          </Popconfirm>
        );
      },
    }] : [])
  ]);

  const deleteBrand = async (record) => {
   console.log("dete", record.brandId)

  if(!record?.brandId) return;

    let res = await AuthService.deleteBrand(record?.brandId);
    console.log("deleted res", res);
    if(res){
      messageApi.open({
        type: 'success',
        content: 'Brendi u fshi me sukses!',
    });
    getBrands();
    }
  }



  const getBrands = async () => {
    setLoading(true);
    let res = await AuthService.getBrands({});
    console.log("res", res);
    if (res?.items && res?.items.length > 0) {
      setBrands(res?.items);
    }
    setLoading(false);
  }

  useEffect(() => {
    getBrands();
  }, [])


  return (
    <>
      <div className="container">
{contextHolder}

        <div className="d-flex justify-content-between align-items-center mb-2">
          <Title level={4} style={{ fontWeight: '400', fontFamily: 'Source Sans 3' }}>Brendet</Title>
          <Link to="/brands/new" style={{ display: "flex" }}>
            <Button type="primary">Shto një të ri</Button>
          </Link>
        </div>

        {brands && <Spin spinning={loading} tip="Duke procesuar te dhenat..."><Table dataSource={brands} size="small" columns={columns} style={{ marginTop: 20 }} /> </ Spin>}




      </div>
    </>
  )
}

export default Brands

const Preloader = styled.div`
position: absolute;
top: 0;
left: 0;
right: 0;
bottom: 0;
background-color: rgba(0,0,0,0.2);
z-index:99;
`
// const Preloader = () => {
//   return (
//     // <div style=></div>
//   )
// }